import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

import { Button } from "@icg360/design-system";

import { ErrorMessage } from "components/error-message";
import { useIsLoggedInQuery } from "gql/__generated__/hooks";
import { useLogout } from "hooks/use-logout-user";
import { captureException } from "utils";

import styles from "./full-page-error.module.scss";

const FullPageError = () => {
  const { logout } = useLogout();
  const error = useRouteError();
  const { data: isLoggedInResponse } = useIsLoggedInQuery();
  const loggedIn = isLoggedInResponse?.isLoggedIn?.loggedIn;

  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <ErrorMessage>
      {loggedIn ? (
        <Button
          appearance="secondary"
          size="sm"
          className={styles.logoutButton}
          onPress={logout}
          data-testid="logout-btn"
        >
          Log out
        </Button>
      ) : null}
    </ErrorMessage>
  );
};

export default FullPageError;
